import RouterPageView from '@/components/RouterPageView'
import DefaultLayout from '@/components/DefaultLayout'

// 设置相关
var settingChildren = [{
  path: 'Index',
  component: () => import(/* webpackChunkName: "setting-Index" */ '@/components/setting/Index')
}, {
  path: 'Department',
  component: () => import(/* webpackChunkName: "setting-Department" */ '@/components/setting/Department')
}, {
  path: 'DepartmentEdit',
  component: () => import(/* webpackChunkName: "setting-DepartmentEdit" */ '@/components/setting/DepartmentEdit')
}, {
  path: 'DepartmentUserEdit',
  component: () => import(/* webpackChunkName: "setting-DepartmentUserEdit" */ '@/components/setting/DepartmentUserEdit')
}, {
  path: 'UserDepartmentEdit',
  component: () => import(/* webpackChunkName: "setting-UserDepartmentEdit" */ '@/components/setting/UserDepartmentEdit')
}, {
  path: 'Trigger',
  component: () => import(/* webpackChunkName: "setting-Trigger" */ '@/components/setting/Trigger')
}, {
  path: 'TriggerEdit',
  component: () => import(/* webpackChunkName: "setting-TriggerEdit" */ '@/components/setting/TriggerEdit')
}, {
  path: 'View',
  component: () => import(/* webpackChunkName: "setting-View" */ '@/components/setting/View')
}, {
  path: 'ViewEdit',
  component: () => import(/* webpackChunkName: "setting-ViewEdit" */ '@/components/setting/ViewEdit')
}, {
  path: 'Template',
  component: () => import(/* webpackChunkName: "setting-Template" */ '@/components/setting/Template')
}, {
  path: 'TemplateEdit',
  component: () => import(/* webpackChunkName: "setting-TemplateEdit" */ '@/components/setting/TemplateEdit')
}, {
  path: 'Webhook',
  component: () => import(/* webpackChunkName: "setting-Webhook" */ '@/components/setting/Webhook')
}, {
  path: 'WebhookEdit',
  component: () => import(/* webpackChunkName: "setting-WebhookEdit" */ '@/components/setting/WebhookEdit')
}, {
  path: 'TicketViaMail',
  component: () => import(/* webpackChunkName: "setting-TicketViaMail" */ '@/components/setting/TicketViaMail')
}, {
  path: 'TicketViaMailEdit',
  component: () => import(/* webpackChunkName: "setting-TicketViaMailEdit" */ '@/components/setting/TicketViaMailEdit')
}, {
  path: 'WebhookLog',
  component: () => import(/* webpackChunkName: "setting-WebhookLog" */ '@/components/setting/WebhookLog')
}, {
  path: 'TicketWorkflowInstance',
  component: () => import(/* webpackChunkName: "setting-TicketWorkflowInstance" */ '@/components/setting/TicketWorkflowInstance')
}, {
  path: 'TicketLink',
  component: () => import(/* webpackChunkName: "setting-TicketLink" */ '@/components/setting/TicketLink')
}, {
  path: 'Workflow',
  component: () => import(/* webpackChunkName: "setting-Workflow" */ '@/components/setting/Workflow')
}, {
  path: 'WorkflowEdit',
  component: () => import(/* webpackChunkName: "setting-WorkflowEdit" */ '@/components/setting/WorkflowEdit')
}, {
  path: 'TicketWidget',
  component: () => import(/* webpackChunkName: "setting-TicketWidget" */ '@/components/setting/TicketWidget')
}, {
  path: 'TicketWidgetEdit',
  component: () => import(/* webpackChunkName: "setting-TicketWidgetEdit" */ '@/components/setting/TicketWidgetEdit')
}, {
  path: 'TicketType',
  component: () => import(/* webpackChunkName: "setting-TicketType" */ '@/components/setting/TicketType')
}, {
  path: 'TicketTypeEdit',
  component: () => import(/* webpackChunkName: "setting-TicketTypeEdit" */ '@/components/setting/TicketTypeEdit')
}, {
  path: 'TicketVia',
  component: () => import(/* webpackChunkName: "setting-TicketVia" */ '@/components/setting/TicketVia')
}, {
  path: 'TicketViaEdit',
  component: () => import(/* webpackChunkName: "setting-TicketViaEdit" */ '@/components/setting/TicketViaEdit')
}, {
  path: 'Organization',
  component: () => import(/* webpackChunkName: "setting-Organization" */ '@/components/setting/Organization')
}, {
  path: 'OrganizationEdit',
  component: () => import(/* webpackChunkName: "setting-OrganizationEdit" */ '@/components/setting/OrganizationEdit')
}, {
  path: 'Leader',
  component: () => import(/* webpackChunkName: "setting-Leader" */ '@/components/setting/Leader')
}, {
  path: 'Staff',
  component: () => import(/* webpackChunkName: "setting-Staff" */ '@/components/setting/Staff')
}, {
  path: 'TicketOrigin',
  component: () => import(/* webpackChunkName: "setting-TicketOrigin" */ '@/components/setting/TicketOrigin')
}, {
  path: 'TicketStatus',
  component: () => import(/* webpackChunkName: "setting-TicketStatus" */ '@/components/setting/TicketStatus')
}, {
  path: 'TicketStatusEdit',
  component: () => import(/* webpackChunkName: "setting-TicketStatusEdit" */ '@/components/setting/TicketStatusEdit')
}, {
  path: 'Tag',
  component: () => import(/* webpackChunkName: "setting-Tag" */ '@/components/setting/Tag')
}, {
  path: 'Project',
  component: () => import(/* webpackChunkName: "setting-ProjectList" */ '@/components/setting/ProjectList')
}, {
  path: 'ProjectEdit',
  component: () => import(/* webpackChunkName: "setting-ProjectEdit" */ '@/components/setting/ProjectEdit')
}, {
  path: 'UserDepartment',
  component: () => import(/* webpackChunkName: "setting-UserDepartment" */ '@/components/setting/UserDepartment')
}];

// 工单相关
var ticketChildren = [
  {
    path: 'view',
    component: () => import(/* webpackChunkName: "ticket-view" */ '@/views/ticket-view')
  },
  {
    path: 'detail',
    component: () => import(/* webpackChunkName: "ticket-detail" */ '@/views/ticket-detail')
  },
  {
    path: 'user-manage',
    component: () => import(/* webpackChunkName: "user-manage" */ '@/views/user-manage')
  },
  {
    path: 'report',
    component: () => import(/* webpackChunkName: "report" */ '@/views/report'),
    redirect: '/ticket-vue/ticket/report/index',
    children: [{
      path: 'index',
      component: () => import(/* webpackChunkName: "ReportIndex" */ '@/components/ReportIndex'),
    }, {
      path: 'user',
      component: () => import(/* webpackChunkName: "TicketUserReport" */ '@/views/report/TicketUserReport'),
    }, {
      path: 'echarts',
      component: () => import(/* webpackChunkName: "TicketReport-echarts" */ '@/views/report/TicketReportEcharts'),
    }]
  },
  {
    path: 'user-staff',
    component: () => import(/* webpackChunkName: "user-staff" */ '@/views/user-staff')
  }
];

// 所有路由
var routeChildren = [
  {
    path: 'ticket',
    component: RouterPageView,
    redirect: '/ticket-vue/ticket/view',
    children: ticketChildren
  },
  {
    path: 'setting',
    component: () => import(/* webpackChunkName: "setting" */ '@/views/setting'),
    redirect: '/ticket-vue/setting/Index',
    children: settingChildren
  },
  {
    path: 'd',
    component: () => import(/* webpackChunkName: "mobile-ticket-detail" */ '@/views/mobile/mobile-ticket-detail')
  },
  {
    path: 'n',
    component: () => import(/* webpackChunkName: "mobile-ticket-new" */ '@/views/mobile/mobile-ticket-new')
  },
  {
    path: 'c',
    component: () => import(/* webpackChunkName: "mobile-ticket-complaint-new" */ '@/views/mobile/mobile-ticket-complaint-new')
  },
  {
    path: 'f',
    component: () => import(/* webpackChunkName: "mobile-ticket-feedback" */ '@/views/mobile/mobile-ticket-feedback')
  },
  {
    path: 'n2',
    component: () => import(/* webpackChunkName: "mobile-ticket-new-2" */ '@/views/mobile/mobile-ticket-new-2')
  },
  {
    path: 'v',
    component: () => import(/* webpackChunkName: "mobile-ticket-view" */ '@/views/mobile/mobile-ticket-view')
  },
  {
    path: 'debug',
    component: () => import(/* webpackChunkName: "mobile-ticket-debug" */ '@/views/mobile/mobile-ticket-debug')
  },
  {
    path: 'my',
    component: () => import(/* webpackChunkName: "my" */ '@/views/mobile/mobile-ticket-my')
  },
  {
    path: 'view-list',
    component: () => import(/* webpackChunkName: "mobile-ticket-view-list" */ '@/views/mobile/mobile-ticket-view-list')
  },
  {
    path: 'view-one',
    component: () => import(/* webpackChunkName: "mobile-ticket-view-one" */ '@/views/mobile/mobile-ticket-view-one')
  },
  {
    path: 'search',
    component: () => import(/* webpackChunkName: "mobile-ticket-search" */ '@/views/mobile/mobile-ticket-search')
  },
  {
    path: 'event',
    component: () => import(/* webpackChunkName: "mobile-ticket-event" */ '@/views/mobile/mobile-ticket-event')
  },
  {
    path: 'me',
    component: () => import(/* webpackChunkName: "mobile-ticket-user-me" */ '@/views/mobile/mobile-ticket-user-me')
  },
  {
    path: 'login',
    component: () => import(/* webpackChunkName: "login" */ '@/views/login')
  },
  {
    path: 'NewTicket',  //外部系统会用到这个地址 比如授信申请 这里做个兼容
    redirect: '/ticket-vue/new-ticket'
  },
  {
    path: 'new-ticket',
    component: () => import(/* webpackChunkName: "new-ticket" */ '@/views/new-ticket')
  },
  {
    path: 'wenjuan',
    component: () => import(/* webpackChunkName: "wenjuan" */ '@/views/wenjuan')
  },
  {
    path: 'article',
    component: () => import(/* webpackChunkName: "article" */ '@/views/article')
  },
  {
    path: 'toupiao',
    component: () => import(/* webpackChunkName: "toupiao" */ '@/views/toupiao')
  },
  {
    path: 'oa',
    component: () => import(/* webpackChunkName: "oa" */ '@/views/oa')
  },
  {
    path: 'u',
    component: () => import(/* webpackChunkName: "user" */ '@/views/user')
  },
  {
    path: 'UserNotifyConfig',
    component: () => import(/* webpackChunkName: "UserNotifyConfig" */ '@/views/UserNotifyConfig')
  }
];

// 导出
export default {
  path: '/ticket-vue',
  redirect: '/ticket-vue/ticket',
  component: DefaultLayout,
  children: routeChildren
}


// WEBPACK FOOTER //
// ./src/router/ticket.js